import { EPlanStatus, EServiceType } from "./MyPlans/IMyPlans";
import { ERole } from "./User/newUser";

export interface IQuery {
  page: number;
  pageSize: number;
  id?: string | number;
  sortOrder?: string;
  order_by?: string;
  emphasis?: string;
  organization_id?: string;
  white_label_id?: string;
}

export interface IQueryMyPlans {
  status: EPlanStatus | "";
  enabled?: boolean;
}

export interface IQueryMyProducts {
  active: EServiceType;
  enabled?: boolean;
}

export enum EOrderStatus {
  ALL = "",
  NEW = "NEW",
  PARTIALLY_FILLED = "PARTIALLY_FILLED",
  FILLED = "FILLED",
  DONE_FOR_DAY = "DONE_FOR_DAY",
  CANCELED = "CANCELED",
  REPLACED = "REPLACED",
  PENDING_CANCEL = "PENDING_CANCEL",
  STOPPED = "STOPPED",
  REJECTED = "REJECTED",
  SUSPENDED = "SUSPENDED",
  PENDING_NEW = "PENDING_NEW",
  CALCULATED = "CALCULATED",
  EXPIRED = "EXPIRED",
  ACCEPTED_FOR_BIDDING = "ACCEPTED_FOR_BIDDING",
  PENDING_REPLACE = "PENDING_REPLACE",
}

export enum EOrderSide {
  ALL = "",
  BUY = "BUY",
  SELL = "SELL",
}

export enum ETypeClient {
  ALL = "",
  document_nr = "document_nr",
  email = "email",
  name = "name",
}

export enum EStatusHistory {
  Info = "Info",
  InProcessing = "InProcessing",
  Scheduled = "Scheduled",
  Error = "Error",
  CancelledByAnalyst = "CancelledByAnalyst",
  CancelledByUser = "CancelledByUser",
  Executed = "Executed",
  Accepted = "Accepted",
}

export enum EIsOpen {
  ALL = "",
  TRUE = "true",
  FALSE = "false",
}

export enum ESortOrder {
  all = "",
  ASC = "ASC",
  DESC = "DESC",
}
export interface IQueryOrderPosition {
  productId: number;
  page: number;
  pageSize: number;
  sortOrder?: string;
  orderBy?: string;
  order_status?: EOrderStatus[];
  order_side?: EOrderSide | string;
  is_open?: EIsOpen | string;
  isProduct?: boolean;
  sending_time_start: Date;
  sending_time_end: Date | null;
}

export interface IQueryPosition {
  page: number;
  pageSize: number;
  productId?: number[];
  open_date_start: Date;
  open_date_end: Date | null;
  is_open?: EIsOpen | string;
  order_side?: EOrderSide | string;
  order_status?: EOrderStatus[];
  sortOrder?: ESortOrder | string;
  orderBy?: string;
  roleSelected?: ERole | null;
  isEnabled?: boolean;
  client_id?: string | null;
}

export interface IQueryPositionDetail {
  id: string;
  page: number;
  pageSize: number;
  sortOrder?: ESortOrder | string;
  orderBy?: string;
  isAnalytic?: boolean;
  client_id?: string | null;
}

export interface IQueryOrder {
  page: number;
  pageSize: number;
  productId?: number[];
  open_date_start: Date;
  open_date_end: Date | null;
  is_open?: EIsOpen | string;
  order_side?: EOrderSide | string;
  order_status?: EOrderStatus[];
  sortOrder?: ESortOrder | string;
  orderBy?: string;
  position_id?: number;
  roleSelected?: ERole | null;
  isEnabled?: boolean;
  client_id?: string | null;
}

export interface IQueryOrderDetail {
  id: string;
  page: number;
  pageSize: number;
  sortOrder?: ESortOrder | string;
  orderBy?: string;
  isAnalytic?: boolean;
  order_status?: EOrderStatus[];
  client_id?: string | null;
}

export interface IQueryPredictiveOrder {
  page?: number;
  pageSize?: number;
  orderBy?: string;
  sortOrder?: ESortOrder | string;
  id?: number;
}

export interface IQueryPredictiveOrderExecutions {
  page: number;
  pageSize: number;
  orderBy?: string;
  sortOrder?: ESortOrder | string;
  id: number;
}
